import { createContext } from 'react';

export const typingContext = createContext();
export const countersContext = createContext();